import { Component, OnInit, OnDestroy } from '@angular/core';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { VocsService } from '../../../services/vocs.service';
import { Manuscript } from '../../../models/manuscript';
import { VocTerms } from '../../../models/voc-term';
import { MsHistoryCopyList } from '../../../models/ms-history-copy';
import { MsImageLink } from '../../../models/ms-image-link';
import { NameList } from '../../../models/name-list';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-ms-details-history',
  templateUrl: './ms-details-history.component.html',
  styleUrls: ['./ms-details-history.component.css']
})
export class MsDetailsHistoryComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    manuscript: Manuscript; // current manuscript data
    historyCopies: MsHistoryCopyList; // current manuscript history copies
    placesVoc: VocTerms; // vocabulary of places
    annotationTypesVoc: VocTerms; // vocabulary of image annotation types
    patrons: NameList;
    owners: NameList;

    constructor(
        private manuscriptsService: ManuscriptsService,
        private vocsService: VocsService
        ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.manuscriptsService.getManuscript()
                .subscribe(response => this.manuscript = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptHistoryCopies()
                .subscribe(response => this.historyCopies = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptHistoryPatrons()
                .subscribe(response => this.patrons = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptHistoryOwners()
                .subscribe(response => this.owners = response, err => console.error(err)),
            this.vocsService.getMsCopyPlaces()
                .subscribe(response => this.placesVoc = response, err => console.error(err)),
            this.vocsService.getAnnotationTypes()
                .subscribe(response => this.annotationTypesVoc = response, err => console.error(err))
        );
    }

    selectImage(imageLink: MsImageLink): void {
        this.manuscriptsService.selectMsImageLink(imageLink);
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/ms-details-history/ms-details-history.component.ts